import { Injectable } from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import { BehaviorSubject } from 'rxjs';
import { MapView } from 'src/app/components/split-view/split-view.component';

@Injectable({
  providedIn: 'root'
})
export class SplitViewService {
  onEvent$: BehaviorSubject<IOnEvent> = new BehaviorSubject({})
  // selectedMap: mapboxgl.Map
  isSplitscreenOn = false
  // selectedOrtho = null
  addingMap = false

  isEditingAnnotation?: boolean = false
  get selectedMapView() {
    return this.mapViews[this.selectedMapViewIndex]
  }

  get selectedOrtho() {
    return this.selectedMapView.ortho
  }

  get selectedMap() {
    return this.selectedMapView.map
  }

  // maps: mapboxgl.Map[]
  mapViews: MapView[]
  selectedMapViewIndex: number
  // orthos: any[]
  lastActiveDrawIds = {}
  MAX_MAP_VIEW_COUNT?: number
  
  constructor() { }
}

export interface IOnEvent {
  isSplitscreenOn?: boolean,
  skipZoom?: boolean,
  onClickAdd?: boolean,
  onResetMapLayer?: boolean,
  onCardAnnotClicked?: boolean,
  onAddOrtho?: boolean,
  onActiveMapChange?: { map: any, map_layer: any }
  orthoLayer?: any,
  onClickRemove?: boolean,
  onClickUnsync?: boolean,
  onClickResync?: boolean,
  refreshAnchorButton?: boolean,
  _maps?,
  _draws?,
  onClickResetPitch?: boolean,
  onClickResetBearing?: boolean,
  onFitBounds?: boolean,
  bounds?,
  offset?,
  onRemoveAllSplitScreen?: boolean,
  toggleTimeLine?: boolean,
}
